import type { StaticImageData } from "next/image"

import { Trans, useBounceGlobalValues } from "@bounce/i18n"

import bagsImg from "@bounce/assets/big-icons/luggage.png"
import protectionImg from "@bounce/assets/big-icons/shield-check.png"
import locationsImg from "@bounce/assets/big-icons/store.png"
import supportImg from "@bounce/assets/big-icons/user.png"

type Metric = {
  src: StaticImageData
  text: React.ReactNode
}

export const useMetrics = (): Metric[] => {
  const bounceGlobals = useBounceGlobalValues()

  const components = {
    bold: <span className="title4 mb-1" />,
    text: <span className="paragraph2 font-bold" />,
  }

  return [
    {
      src: locationsImg,
      text: (
        <Trans
          ns="marketing-ls-app"
          i18nKey="hooks.useMetrics.metric1"
          defaults="<bold>{{numLocations}}+</bold><br /><text>locations worldwide</text>"
          components={components}
          values={{
            numLocations: bounceGlobals.numLocations,
          }}
        />
      ),
    },
    {
      src: protectionImg,
      text: (
        <Trans
          ns="marketing-ls-app"
          i18nKey="hooks.useMetrics.metric2"
          defaults="<bold>{{bounceShieldProtection}}</bold><br /><text>protection</text>"
          components={components}
          values={{
            bounceShieldProtection: bounceGlobals.bounceShieldProtection,
          }}
        />
      ),
    },
    {
      src: bagsImg,
      text: (
        <Trans
          ns="marketing-ls-app"
          i18nKey="hooks.useMetrics.metric3"
          defaults="<bold>{{numBagsStored}}+</bold><br /><text>bags stored</text>"
          components={components}
          values={{
            numBagsStored: bounceGlobals.numBagsStored,
          }}
        />
      ),
    },
    {
      src: supportImg,
      text: (
        <Trans
          ns="marketing-ls-app"
          i18nKey="hooks.useMetrics.metric4"
          defaults="<bold>24/7</bold><br /><text>support</text>"
          components={components}
        />
      ),
    },
  ]
}
